import React, { useEffect } from "react";
import { Table, Tooltip, Switch, Space } from "antd";
import { useCustomerModel } from "../customerModel";
import { momentFormat } from "@/erp_subpackage/utils/util"

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading, searchParam,
        loadData, setSelectedRowKeys, onDisabled
    } = useCustomerModel();

    useEffect(() => {
        loadData()
    }, [])

    const columns = [
        {
            title: '序号',
            width: 80,
            align: "center",
            dataIndex: 'branch',
            fixed: "left",
            render: (text, record, index) => index + 1
        }, {
            title: '客户编码',
            width: 160,
            dataIndex: "code",
            fixed: "left",
        }, {
            title: '客户名称',
            width: 260,
            dataIndex: 'name',
            fixed: "left",
            render: (text, record) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
        }, {
            title: '所属机构',
            width: 160,
            dataIndex: 'shopName',
            render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
        }, {
            title: '联系人',
            width: 80,
            dataIndex: 'contact',
        }, {
            title: '联系电话',
            width: 160,
            dataIndex: 'phone'
        }, {
            title: '登记日期',
            width: 260,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '联系地址',
            width: 160,
            dataIndex: 'address',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        }, {
            title: "操作",
            align: "center",
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    <Switch checked={text === 1} disabled={searchParam.shopId} onChange={(checked) => {
                        onDisabled(record.id, checked);
                    }} />
                </Space>
            ),
        },
    ];

    //点击行选高亮
    const onRow = (id) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id}
            loading={{ tip: "列表加载中...", spinning: loading }}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={dataSource.length ? { x: 'max-content', y: "calc(100vh - 430px)" } : { x: 'max-content' }}
        />
    )
}
